import { useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { AI_SUGGESTIONS } from "../constants";

import { usePlaceholderTypingAnimation } from "./usePlaceholderTypingAnimation";

export const AnimatedPlaceholder = () => {
    const { translate } = useTranslate();

    const texts = useMemo(
        () =>
            [translate("si.homepage.autocomplete.placeholder"), ...AI_SUGGESTIONS.map((s) => translate(s.label))].map(
                (text) => `${text}...`,
            ),
        [translate],
    );

    const displayedText = usePlaceholderTypingAnimation({ texts });

    return (
        <Text
            fontVariant="body2"
            color={colorsPalettes.carbon[300]}
            display="block"
            data-automation="homepage-autocomplete-animated-placeholder"
            margin="0 0 0 36px"
        >
            {displayedText}
        </Text>
    );
};
